import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class NetworkService {

    constructor(public https: HttpClient) {
        
    }

    public getExternalIP(): Promise<any> {
        return this.https.get('https://api.ipify.org?format=json').toPromise();
    }

    public getConnectionStatus() {
        return fetch(`/onboarding-fopa/assets/status.json?v=${Date.now()}`, {
          cache: 'no-cache'
        });
      }
}
